import { createAction } from 'redux-actions';
import { GET_USERS_FILTER } from '../constants/get';

export const getUsersFilters = createAction(GET_USERS_FILTER, (us) => us);